var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var _a, _b;
/* eslint-disable react-hooks/exhaustive-deps */
import 'setimmediate';
import { Protocol } from '@uniswap/router-sdk';
import { CurrencyAmount, TradeType } from '@uniswap/sdk-core';
import { SupportedChainId } from '../../../../constants/chains';
import { USDC_MAINNET } from '../../../../constants/tokens';
import tryParseCurrencyAmount from '../../../../utils/tryParseCurrencyAmount';
import { getRoutingAPIArguments } from './routing/useRoutingAPIArguments';
import { TradeState } from './types/types';
import { computeRoutes, transformRoutesToTrade } from './types/utils';
export var STABLECOIN_AMOUNT_OUT = (_a = {},
    _a[SupportedChainId.MAINNET] = CurrencyAmount.fromRawAmount(USDC_MAINNET, 100000000000),
    _a);
/**

/**
 *
 * @param fiatValue string representation of a USD amount
 * @returns CurrencyAmount where currency is stablecoin on active chain
 */
export function getStablecoinAmountFromFiatValue(fiatValue, chainId) {
    var _a;
    var stablecoin = chainId ? (_a = STABLECOIN_AMOUNT_OUT[chainId]) === null || _a === void 0 ? void 0 : _a.currency : undefined;
    return function () {
        if (fiatValue === null || fiatValue === undefined || !chainId || !stablecoin) {
            return undefined;
        }
        // trim for decimal precision when parsing
        var parsedForDecimals = parseFloat(fiatValue).toFixed(stablecoin.decimals).toString();
        try {
            // parse USD string into CurrencyAmount based on stablecoin decimals
            return tryParseCurrencyAmount(parsedForDecimals, stablecoin);
        }
        catch (error) {
            return undefined;
        }
    };
}
/**
 * Reduces client-side latency by increasing the minimum percentage of the input token to use for each route in a split route while SOR is used client-side.
 * Defaults are defined in https://github.com/Uniswap/smart-order-router/blob/309e6f6603984d3b5aef0733b0cfaf129c29f602/src/routers/alpha-router/config.ts#L83.
 */
var DistributionPercents = (_b = {},
    _b[SupportedChainId.MAINNET] = 10,
    _b[SupportedChainId.OPTIMISM] = 10,
    _b[SupportedChainId.OPTIMISTIC_KOVAN] = 10,
    _b[SupportedChainId.ARBITRUM_ONE] = 25,
    _b[SupportedChainId.ARBITRUM_RINKEBY] = 25,
    _b);
var DEFAULT_DISTRIBUTION_PERCENT = 10;
function getConfig(chainId, protocol) {
    var _a;
    return {
        // Limit to only V2 and V3.
        protocols: protocol === 'V2' ? [Protocol.V2] : [Protocol.V3],
        distributionPercent: (_a = (chainId && DistributionPercents[chainId])) !== null && _a !== void 0 ? _a : DEFAULT_DISTRIBUTION_PERCENT,
    };
}
export default function getClientSideSmartOrderRouterTrade(_a) {
    var _b, _c, _d, _e, _f;
    var library = _a.library, tradeType = _a.tradeType, protocol = _a.protocol, amountSpecified = _a.amountSpecified, otherCurrency = _a.otherCurrency;
    return __awaiter(this, void 0, void 0, function () {
        var _g, currencyIn, currencyOut, queryArgs, chainId, params, config, getQuoteResult, quoteResult, route, gasUseEstimateUSD, getTrade, trade, otherAmount;
        var _this = this;
        return __generator(this, function (_h) {
            switch (_h.label) {
                case 0:
                    _g = __read(tradeType === TradeType.EXACT_INPUT
                        ? [amountSpecified === null || amountSpecified === void 0 ? void 0 : amountSpecified.currency, otherCurrency]
                        : [otherCurrency, amountSpecified === null || amountSpecified === void 0 ? void 0 : amountSpecified.currency], 2), currencyIn = _g[0], currencyOut = _g[1];
                    queryArgs = getRoutingAPIArguments({
                        tokenIn: currencyIn,
                        tokenOut: currencyOut,
                        amount: amountSpecified,
                        tradeType: tradeType,
                        useClientSideRouter: true,
                    });
                    chainId = amountSpecified === null || amountSpecified === void 0 ? void 0 : amountSpecified.currency.chainId;
                    params = chainId && library && { chainId: chainId, provider: library };
                    config = getConfig(chainId, protocol);
                    getQuoteResult = function () { return __awaiter(_this, void 0, void 0, function () {
                        var quoteResult_1, e_1;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!queryArgs || !params)
                                        return [2 /*return*/, { error: undefined }];
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([1, 4, , 5]);
                                    return [4 /*yield*/, import('./routing/clientSideSmartOrderRouter')];
                                case 2: return [4 /*yield*/, (_a.sent()).getClientSideQuote(queryArgs, params, config)
                                    // There is significant post-fetch processing, so delay a tick to prevent dropped frames.
                                    // This is only important in the context of integrations - if we control the whole site,
                                    // then we can afford to drop a few frames.
                                ];
                                case 3:
                                    quoteResult_1 = _a.sent();
                                    // There is significant post-fetch processing, so delay a tick to prevent dropped frames.
                                    // This is only important in the context of integrations - if we control the whole site,
                                    // then we can afford to drop a few frames.
                                    return [2 /*return*/, new Promise(function (resolve) { return setImmediate(function () { return resolve(quoteResult_1); }); })];
                                case 4:
                                    e_1 = _a.sent();
                                    console.error({ error: e_1 });
                                    return [2 /*return*/, { error: true }];
                                case 5: return [2 /*return*/];
                            }
                        });
                    }); };
                    return [4 /*yield*/, getQuoteResult()];
                case 1:
                    quoteResult = _h.sent();
                    route = computeRoutes(currencyIn, currencyOut, tradeType, quoteResult.data);
                    gasUseEstimateUSD = (_c = getStablecoinAmountFromFiatValue((_b = quoteResult === null || quoteResult === void 0 ? void 0 : quoteResult.data) === null || _b === void 0 ? void 0 : _b.gasUseEstimateUSD, chainId)()) !== null && _c !== void 0 ? _c : null;
                    getTrade = function () {
                        if (route) {
                            try {
                                return route && transformRoutesToTrade(route, tradeType, gasUseEstimateUSD);
                            }
                            catch (e) {
                                console.debug('transformRoutesToTrade failed: ', e);
                            }
                        }
                        return;
                    };
                    trade = getTrade();
                    if (!currencyIn || !currencyOut) {
                        return [2 /*return*/, { state: TradeState.INVALID, trade: undefined }];
                    }
                    if (!trade) {
                        return [2 /*return*/, { state: TradeState.LOADING, trade: undefined }];
                    }
                    otherAmount = undefined;
                    if ((_d = quoteResult.data) === null || _d === void 0 ? void 0 : _d.route) {
                        switch (tradeType) {
                            case TradeType.EXACT_INPUT:
                                otherAmount = CurrencyAmount.fromRawAmount(currencyOut, (_e = quoteResult.data) === null || _e === void 0 ? void 0 : _e.amount);
                                break;
                            case TradeType.EXACT_OUTPUT:
                                otherAmount = CurrencyAmount.fromRawAmount(currencyIn, (_f = quoteResult.data) === null || _f === void 0 ? void 0 : _f.amount);
                                break;
                        }
                    }
                    if (!otherAmount || !route || route.length === 0) {
                        return [2 /*return*/, { state: TradeState.NO_ROUTE_FOUND, trade: undefined }];
                    }
                    if (trade) {
                        return [2 /*return*/, { state: TradeState.VALID, trade: trade }];
                    }
                    return [2 /*return*/, { state: TradeState.INVALID, trade: undefined }];
            }
        });
    });
}
